import dispatcher from "../Dispatcher";
import actionTypes from "./ActionTypes";
import axios from "axios";
import * as Globals from "../Globals";
import { PostAlert } from "./AlertActions";
import { Logout } from "./LoginActions";
export function LoadDefaults() {
  axios.get(`${Globals.baseUrl}/Defaults/LoadDefaults`, {
    headers: {
      "content-type": "application/json; charset=utf-8",
      Authorization: `Bearer ${Globals.getJwtToken()}`
    }
  }).then((res) => {
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.GetDefaults,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function LoadDefaultsByBP(bp) {
  console.log("load");
  axios.get(`${Globals.baseUrl}/Defaults/LoadDefaultsByBP/${bp}`, {
    headers: {
      "content-type": "application/json; charset=utf-8",
      Authorization: `Bearer ${Globals.getJwtToken()}`
    }
  }).then((res) => {
    if (res.status === 200) {
      console.log("Results");
      dispatcher.dispatch({
        actionType: actionTypes.GetDefaultsByBP,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function LoadDefault(id) {
  axios.post(
    `${Globals.baseUrl}/Defaults/GetDefault`,
    { Id: id },
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.GetDefault,
        Result: res.data
      });
    } else if (res.status === 400 || res.status === 401) {
      console.log("error: 401");
    }
  }).catch((res) => {
    console.log("IS error");
  });
}
export function UpdateDefault(defaults) {
  console.log(defaults);
  axios.post(
    `${Globals.baseUrl}/Defaults/UpdateDefault`,
    { update: defaults },
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.DefaultUpdate,
        Result: res.data
      });
      PostAlert("success", "Defaults Updated");
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function SaveAsDefault(defaults) {
  console.log(defaults);
  axios.post(
    `${Globals.baseUrl}/Defaults/SaveAsDefault`,
    { update: defaults },
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.DefaultSaveAs,
        Result: res.data
      });
      PostAlert("success", "New Default Created");
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function DeleteDefault(defaults) {
  console.log(defaults);
  axios.post(
    `${Globals.baseUrl}/Defaults/DeleteDefault`,
    { update: defaults },
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      let result = res.data;
      if (result.resultStatus === "Success") {
        dispatcher.dispatch({
          actionType: actionTypes.DefaultDelete,
          Result: res.data
        });
        PostAlert("success", "Default Deleted");
      } else {
        PostAlert("error", "Unable to remove default");
      }
    }
  }).catch((error) => {
    if (error.response && error.response.status === 401) {
      console.log("error: 401. Logging user out...");
      Logout();
    } else {
      console.log("Request failed:", error);
    }
  });
}
export function GetDefaultDetails() {
  axios.get(
    `${Globals.baseUrl}/Defaults/GetDefaultDetails`,
    {
      headers: {
        "content-type": "application/json; charset=utf-8",
        Authorization: `Bearer ${Globals.getJwtToken()}`
      }
    }
  ).then((res) => {
    if (res.status === 200) {
      dispatcher.dispatch({
        actionType: actionTypes.DefaultGetDetails,
        Result: res.data
      });
    }
  }).catch((res) => {
    console.log(res);
    if (res.response.status === 401) {
      console.log("unauthorized");
      Logout();
    }
  });
}
